import { render, staticRenderFns } from "./MessengerReceipt.vue?vue&type=template&id=80a8520a&scoped=true"
import script from "./MessengerReceipt.vue?vue&type=script&lang=js"
export * from "./MessengerReceipt.vue?vue&type=script&lang=js"
import style0 from "./MessengerReceipt.vue?vue&type=style&index=0&id=80a8520a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a8520a",
  null
  
)

export default component.exports